/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Honors_Title_LeadInputs */

const en_about_honors_title_lead = /** @type {(inputs: About_Honors_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teaching &`)
};

const es_about_honors_title_lead = /** @type {(inputs: About_Honors_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enseñanza y`)
};

const de_about_honors_title_lead = /** @type {(inputs: About_Honors_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lehre &`)
};

const zh_about_honors_title_lead = /** @type {(inputs: About_Honors_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`教学与`)
};

const ar_about_honors_title_lead = /** @type {(inputs: About_Honors_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التعليم و`)
};

const fr_about_honors_title_lead = /** @type {(inputs: About_Honors_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enseignement et`)
};

const vi_about_honors_title_lead = /** @type {(inputs: About_Honors_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giảng dạy và`)
};

const sw_about_honors_title_lead = /** @type {(inputs: About_Honors_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ufundishaji na`)
};

const th_about_honors_title_lead = /** @type {(inputs: About_Honors_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การสอนและ`)
};

const bs_about_honors_title_lead = /** @type {(inputs: About_Honors_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nastava i`)
};

const ja_about_honors_title_lead = /** @type {(inputs: About_Honors_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`指導と`)
};

const ko_about_honors_title_lead = /** @type {(inputs: About_Honors_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`교육 및`)
};

const pt_about_honors_title_lead = /** @type {(inputs: About_Honors_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ensino e`)
};

const it_about_honors_title_lead = /** @type {(inputs: About_Honors_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insegnamento e`)
};

const sv_about_honors_title_lead = /** @type {(inputs: About_Honors_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Undervisning och`)
};

const nl_about_honors_title_lead = /** @type {(inputs: About_Honors_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lesgeven &`)
};

const da_about_honors_title_lead = /** @type {(inputs: About_Honors_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Undervisning og`)
};

const nb_about_honors_title_lead = /** @type {(inputs: About_Honors_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Undervisning og`)
};

const fi_about_honors_title_lead = /** @type {(inputs: About_Honors_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opetus- ja`)
};

const pl_about_honors_title_lead = /** @type {(inputs: About_Honors_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nauczanie i`)
};

const ru_about_honors_title_lead = /** @type {(inputs: About_Honors_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Преподавание и`)
};

const tr_about_honors_title_lead = /** @type {(inputs: About_Honors_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öğretim ve`)
};

const hi_about_honors_title_lead = /** @type {(inputs: About_Honors_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शिक्षण और`)
};

const id_about_honors_title_lead = /** @type {(inputs: About_Honors_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mengajar &`)
};

const ms_about_honors_title_lead = /** @type {(inputs: About_Honors_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pengajaran &`)
};

const cs_about_honors_title_lead = /** @type {(inputs: About_Honors_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Výuka a`)
};

const el_about_honors_title_lead = /** @type {(inputs: About_Honors_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Διδασκαλία &`)
};

const he_about_honors_title_lead = /** @type {(inputs: About_Honors_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הוראה &`)
};

const af_about_honors_title_lead = /** @type {(inputs: About_Honors_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onderrig en`)
};

const hu_about_honors_title_lead = /** @type {(inputs: About_Honors_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oktatói és`)
};

/**
* | output |
* | --- |
* | "Teaching &" |
*
* @param {About_Honors_Title_LeadInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_honors_title_lead = /** @type {((inputs?: About_Honors_Title_LeadInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Honors_Title_LeadInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_honors_title_lead(inputs)
	if (locale === "de") return de_about_honors_title_lead(inputs)
	if (locale === "zh") return zh_about_honors_title_lead(inputs)
	if (locale === "ar") return ar_about_honors_title_lead(inputs)
	if (locale === "fr") return fr_about_honors_title_lead(inputs)
	if (locale === "vi") return vi_about_honors_title_lead(inputs)
	if (locale === "sw") return sw_about_honors_title_lead(inputs)
	if (locale === "th") return th_about_honors_title_lead(inputs)
	if (locale === "bs") return bs_about_honors_title_lead(inputs)
	if (locale === "ja") return ja_about_honors_title_lead(inputs)
	if (locale === "ko") return ko_about_honors_title_lead(inputs)
	if (locale === "pt") return pt_about_honors_title_lead(inputs)
	if (locale === "it") return it_about_honors_title_lead(inputs)
	if (locale === "sv") return sv_about_honors_title_lead(inputs)
	if (locale === "nl") return nl_about_honors_title_lead(inputs)
	if (locale === "da") return da_about_honors_title_lead(inputs)
	if (locale === "nb") return nb_about_honors_title_lead(inputs)
	if (locale === "fi") return fi_about_honors_title_lead(inputs)
	if (locale === "pl") return pl_about_honors_title_lead(inputs)
	if (locale === "ru") return ru_about_honors_title_lead(inputs)
	if (locale === "tr") return tr_about_honors_title_lead(inputs)
	if (locale === "hi") return hi_about_honors_title_lead(inputs)
	if (locale === "id") return id_about_honors_title_lead(inputs)
	if (locale === "ms") return ms_about_honors_title_lead(inputs)
	if (locale === "cs") return cs_about_honors_title_lead(inputs)
	if (locale === "el") return el_about_honors_title_lead(inputs)
	if (locale === "he") return he_about_honors_title_lead(inputs)
	if (locale === "af") return af_about_honors_title_lead(inputs)
	if (locale === "hu") return hu_about_honors_title_lead(inputs)
	return en_about_honors_title_lead(inputs)
});